import React, {useState} from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
    changeEmail,
    setSettingsChangeEmailModalStatus
} from "../../../store/cabinet/action";
import {registrationFailure} from "../../../store/main/action";
// import {toast} from "react-toastify";

const CabinetSettingsChangeEmailModal = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const userData = useSelector(store => store.cabinet.userData);
    const settingsChangeEmailModalStatus = useSelector(store => store.cabinet.settingsChangeEmailModalStatus);
    const formErr = useSelector(store => store.cabinet.changeEmailStatusErr);
    const changeEmailStatusStarted = useSelector(store => store.cabinet.changeEmailStatusStarted);


    const [email, setEmail] = useState('');
    const [password , setPassword] = useState('');

    const closeModal = () => {
        setEmail('');
        setPassword('');
        dispatch(setSettingsChangeEmailModalStatus(false));
    };

    const isSubmitSuccess = () =>{
        return !changeEmailStatusStarted
    }

    const successHandler = () =>{
        // toast(t('Ваш email успешно изменен!'));
        closeModal();
    }

    const sendFormHandler = () =>{
        if (isSubmitSuccess()) {
            dispatch(changeEmail({email, password}, successHandler));
        }
    }

    return (
        <Popup
            open={settingsChangeEmailModalStatus}
            modal
            nested
            closeOnDocumentClick
            onClose={closeModal}
        >
            <div className={Styles.modalContainer}>
                <div className={Styles.modalCloseBtn} onClick={closeModal}>
                    <div />
                    <div />
                </div>

                <div className={Styles.modalContentWrap}>
                    <div className={Styles.modalTitle}>
                        {t("Изменить Email")}
                    </div>

                    <div className={Styles.inputWrap}>
                        <div className={`${Styles.inputBox} ${formErr?.current_password ? Styles.inputWrapWithErr : null}`}>
                            <div className={Styles.inputBoxTitle}>{t('Ваш текущий email')}</div>
                            <input
                                className={`${Styles.tcInput}`}
                                type="text"
                                value={userData?.user?.email || ''}
                                readOnly={true}
                            />
                            <div className={`${Styles.tcErr}`}/>
                        </div>
                        <div className={`${Styles.inputBox} ${formErr?.email ? Styles.inputWrapWithErr : null}`}>
                            <div className={Styles.inputBoxTitle}>{t('Введите ваш новый email')}</div>
                            <input
                                className={`${Styles.tcInput}`}
                                type="text"
                                placeholder="example@gmail.com"
                                value={email}
                                onChange={(e)=>{setEmail(e.target.value)}}
                                onKeyDown={(event)=>{
                                    if (formErr.email){
                                        delete formErr.email;
                                        dispatch(registrationFailure(formErr));
                                    }
                                }}
                            />
                            <div className={`${Styles.tcErr} ${formErr?.email ? Styles.tcErrActive : null}`}>{formErr?.email ? formErr.email : null}</div>
                        </div>
                        <div className={`${Styles.inputBox} ${formErr?.password ? Styles.inputWrapWithErr : null}`}>
                            <div className={Styles.inputBoxTitle}>{t('Введите ваш пароль')}</div>
                            <input
                                className={`${Styles.tcInput}`}
                                type="password"
                                placeholder="••••••••"
                                value={password}
                                onChange={(e)=>{setPassword(e.target.value)}}
                                onKeyDown={(event)=>{
                                    if (formErr.password){
                                        delete formErr.password;
                                        dispatch(registrationFailure(formErr));
                                    }
                                }}
                            />
                            <div className={`${Styles.tcErr} ${formErr?.password ? Styles.tcErrActive : null}`}>{formErr?.password ? formErr.password : null}</div>
                        </div>
                    </div>

                    <div className={`${Styles.tcBtn}`} onClick={()=>{sendFormHandler()}}>{t('Сохранить')}</div>
                </div>
            </div>
        </Popup>
    );
};

export default CabinetSettingsChangeEmailModal;
